package co.maytes.standupbot.dashboard.features.summary

import co.maytes.standupbot.shared.csv.SummaryItemsCsv
import co.maytes.standupbot.shared.dto.summary.AccomplishmentSummaryDto
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.url.URL

object SummaryCsvExport {
    fun export(dto: AccomplishmentSummaryDto, rangeLabel: String) {
        val suffix = rangeLabel.lowercase().replace(Regex("[^a-z0-9]+"), "-").trim('-')
        triggerDownload("summary-items-$suffix.csv", SummaryItemsCsv.build(dto))
    }

    private fun triggerDownload(filename: String, contents: String) {
        val blob = org.w3c.files.Blob(arrayOf(contents), org.w3c.files.BlobPropertyBag(type = "text/csv;charset=utf-8"))
        val url = URL.createObjectURL(blob)
        val a = document.createElement("a") as HTMLAnchorElement
        a.href = url
        a.setAttribute("download", filename)
        a.style.display = "none"
        document.body?.appendChild(a)
        a.click()
        document.body?.removeChild(a)
        window.setTimeout({ URL.revokeObjectURL(url); null }, 2000)
    }
}
